import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("NEW+ ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Create A New Green Auction.", -1)
const _hoisted_4 = { style: {"margin-left":"10px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"width":"135px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Id ")
const _hoisted_8 = { style: {"width":"300px"} }
const _hoisted_9 = { style: {"width":"135px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Dao Id ")
const _hoisted_11 = { style: {"width":"300px"} }
const _hoisted_12 = { style: {"width":"135px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Dao Name ")
const _hoisted_14 = { style: {"width":"300px"} }
const _hoisted_15 = { style: {"width":"135px"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Start Time ")
const _hoisted_17 = { style: {"width":"300px"} }
const _hoisted_18 = { style: {"width":"135px"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("End Time ")
const _hoisted_20 = { style: {"width":"300px"} }
const _hoisted_21 = { style: {"width":"135px"} }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Start Price ")
const _hoisted_23 = { style: {"width":"300px"} }
const _hoisted_24 = { style: {"width":"135px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Reverse Price ")
const _hoisted_26 = { style: {"width":"300px"} }
const _hoisted_27 = { style: {"width":"135px"} }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Delta Price ")
const _hoisted_29 = { style: {"width":"300px"} }
const _hoisted_30 = { style: {"width":"135px"} }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Type ")
const _hoisted_32 = { style: {"width":"300px","margin-left":"0px"} }
const _hoisted_33 = { style: {"width":"135px"} }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Nft Id ")
const _hoisted_35 = { style: {"width":"300px"} }
const _hoisted_36 = { style: {"width":"135px"} }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Nft Contract ")
const _hoisted_38 = { style: {"width":"300px"} }
const _hoisted_39 = { style: {"width":"135px"} }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Pay Token ")
const _hoisted_41 = { style: {"width":"300px"} }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("cancel")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("approve")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("confirm")
const _hoisted_45 = { class: "card-header" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Id: ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Owner: ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Auction Id: ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Nft Id: ")
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h4", null, "Nft Owner:", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h4", null, "Bid Address:", -1)
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", null, "Auction Result: fail", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, "Auction Result: success", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "Auction Result: success", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", null, "Auction Result: fail", -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Bid")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Claim")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Prev ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Next ")

import { ref, h } from "vue"
import { connected, connectState } from "../libs/connect"
import * as constant from "../constant"
import * as element from "../libs/element"
import * as tools from "../libs/tools"

import { ERC20 } from "../libs/erc20"
import { ERC721 } from "../libs/erc721";
import { GreenDao } from "../libs/greendao"
import { GreenAuction } from "../libs/greenauction"


const __default__ = {
  name: 'AuctionsPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  
const greendao = new GreenDao();
const greenauction = new GreenAuction();

const activeName = connectState.activeName;
const loadStatus = ref(false);
const loadDrawerStatus = ref(false);

const showAddNewAuctionVisiable = ref(false);

const daoId = ref(0);
const daoName = ref('');
const auctionId = ref(0);
const auctionStartTime = ref('');
const auctionEndTime = ref('');
const auctionStartPrice = ref(0);
const auctionReversePrice = ref(0);
const auctionDeltaPrice = ref(0);
const auctionNftId = ref(0);
const auctionNftContract = ref('');
const auctionNftApproved = ref(false);
const auctionPayToken = ref('');
const auctionType = ref(0);

const greenAuctionList = ref(new Array());
const hasMore = ref(false);
const pageSize = ref(6);
const pageCount = ref(0);

const zeroAddress = '0x0000000000000000000000000000000000000000';
const timeFormat = "YYYY/MM/DD hh:mm:ss";

const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

//address explore url
const tokenExplorerUrl = (address:string, tokenId:string = '') => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      if(tokenId != ''){
        return `${blockExplorerUrls}/token/${address}?a=${tokenId}#inventory`
      }
      return `${blockExplorerUrls}/token/${address}`
    }
  }
  return address;
}

//address explore url
const addressExplorerUrl = (address:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return `${blockExplorerUrls}/address/${address}`
    }
  }
  return address;
}      

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }
  return transaction;
}

//get block chain native currency
const getTokenCurencyName = async (token:string) => {
  if(token === zeroAddress){
    for(const i in constant.chainList){
      if(constant.chainList[i].chainId === connectState.chainId){
        return constant.chainList[i].nativeCurrency;
      }
    }
  }else{
    const erc20 = new ERC20(token);
    return await erc20.symbol();
  }
}

//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
};

//get dao id
const getDaoId = () => {
  const daoId = tools.getUrlParamter('daoId');
  try{
    return Number(daoId);
  }catch(e){
    return 0;
  }
}

//update dao name by dao id
const updateDaoName = async (daoId:Number) => {
  const daoInfo = await greendao.getDaoInfoById(daoId);
  daoName.value = daoInfo.daoName;
}

//click to open the drawer to create a new auction
const onAddNewAuctionOpen = async () => {
  daoId.value = getDaoId();
  auctionId.value = 0;
  auctionStartPrice.value = 0;
  auctionReversePrice.value = 0;
  auctionDeltaPrice.value = 0;
  auctionType.value = 0;
  auctionNftId.value = 0;
  auctionNftContract.value = zeroAddress;
  auctionNftApproved.value = false;
  auctionPayToken.value = zeroAddress;

  const now = new Date();
  auctionStartTime.value = now.toLocaleString();

  now.setTime(now.getTime() + 30*24*3600*1000);
  auctionEndTime.value = now.toLocaleString();

  await updateDaoName(daoId.value);
}

//click to cancel auction create
const cancelAuctionUpdate = async () => {
  showAddNewAuctionVisiable.value = false;
}

//click to approve the nft token to the auction contract
const approveNftToken = async () => {
  if(auctionNftApproved.value === true){
    return true;
  }

  try{
    loadDrawerStatus.value = true;

    const erc721 = new ERC721(auctionNftContract.value);

    const contractAddress = (constant.greenAuctionContractAddress as any)[connectState.chainId].toLowerCase();

    const approvedAddress = (await erc721.getApproved(auctionNftId.value)).toLowerCase();

    if(approvedAddress === contractAddress){
      auctionNftApproved.value = true;
    }else{
      const tx = await erc721.approve(contractAddress, auctionNftId.value);
      auctionNftApproved.value = true;
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Approve nft token success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);    
    }

  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//click to confirm to create a new auction
const confirmAuctionUpdate = async () => {
  try{
    loadDrawerStatus.value = true;

    const startTime = new Date(auctionStartTime.value).getTime()/1000;
    const endTime = new Date(auctionEndTime.value).getTime()/1000;

    const tx = await greenauction.mint(startTime, endTime, auctionStartPrice.value, auctionReversePrice.value, auctionDeltaPrice.value, auctionType.value, daoId.value, auctionNftId.value, auctionNftContract.value, auctionPayToken.value);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Create auction success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);    

    showAddNewAuctionVisiable.value = false;

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//click to cancel a green auction
const onCancelGreenAuction = async (auctionId:number) => {
  try{
    const tx = await greenauction.cancelAuction(auctionId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Cancel auction success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }
}

const getCurrentPrice = (auctionInfo:any) => {
  let currentPrice;

  if(auctionInfo.acuType === 0){
    if(auctionInfo.bidPrice === 0){
      currentPrice = auctionInfo.startPrice;
    }else{
      currentPrice = auctionInfo.bidPrice + auctionInfo.priceDelta;
    }
  }else{
    const timeDelta = (new Date()).getTime()/1000 - auctionInfo.startTime;
    currentPrice = auctionInfo.startPrice - (parseInt(timeDelta/86400))*auctionInfo.priceDelta;
  }

  return currentPrice;
}

//click to bid a price for the auction
const onBidAuction = async (auctionInfo:any) => {
  const currentPrice = getCurrentPrice(auctionInfo);

  const opts = {
    message: '',
    confirmButtonText: 'Send',
    cancelButtonText: 'Cancel',
    inputType: 'number',
    inputValue: String(currentPrice),
    inputValidator: (value:number) => {return value >= currentPrice},
    inputErrorMessage: 'bid price must large than current price',
  };

  const erc20 = new ERC20(auctionInfo.payContract);

  const tokenBalance = await erc20.balanceOf(connectState.userAddr.value);

  if(auctionInfo.payContract === zeroAddress){
    opts.message =  h('p', null, [
      h('p', null, 'Please enter the token amount for the auction:'),
      h('p', { style: 'color: teal' }, `dao id: ${auctionInfo.daoId}`),
      h('p', { style: 'color: teal' }, `dao name: ${auctionInfo.daoName}`),
      h('p', { style: 'color: teal' }, `auction id: ${auctionInfo.aucId}`),
      h('p', { style: 'color: teal' }, `token name: ${auctionInfo.tokenSymbol}`),
      h('p', { style: 'color: teal' }, `token balance: ${tokenBalance}`),
    ]);
  }else{
    opts.message =  h('p', null, [
      h('p', null, 'Please enter the token amount for the auction:'),
      h('p', { style: 'color: teal' }, `dao id: ${auctionInfo.daoId}`),
      h('p', { style: 'color: teal' }, `dao name: ${auctionInfo.daoName}`),
      h('p', { style: 'color: teal' }, `auction id: ${auctionInfo.aucId}`),
      h('p', { style: 'color: teal' }, `token name: ${auctionInfo.tokenSymbol}`),
      h('p', { style: 'color: teal' }, `token contract: ${auctionInfo.payContract}`),
      h('p', { style: 'color: teal' }, `token balance: ${tokenBalance}`),
    ]);
  }

  element.elMessageBox('Please enter the token amount for the auction:', 'Send Token', opts, async (value:number) => {
    if(value < currentPrice){
      element.alertMessage(`bid price must large than current price: ${currentPrice}!`);
    }

    try{
      if(auctionInfo.payContract != zeroAddress){
        const tx = await erc20.approve(greenauction.getAddress(), value);
        connectState.transactions.value.unshift(tx);
        connectState.transactionCount.value++;
        const msg = `<div><span>Approve token success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      }

      const tx = await greenauction.bidForNft(auctionInfo.aucId, value);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Bid price for the auction success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;

      handleClick();
    }catch(e){
      element.alertMessage(e);
    }

  });    
}

//click to claim the auction treassure
const onClaimAuction = async (auctionId: number) => {
  try{
    const tx = await greenauction.claimAuction(auctionId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Claim auction success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }
}

//on click for prev page
const onHandlePrev = async () => {
  if(pageCount.value > 0){
    pageCount.value--;
  }
  handleClick();
}

//on click for next page
const onHandleNext = async () => {
  if(hasMore.value){
    pageCount.value++;
  }
  handleClick();
}

//get green auctions infos by page size and page count
const getGreenAuctionCount = async (aucStatus:number, onlyOwner:boolean) => {
  daoId.value = getDaoId();

  const indexs = await greenauction.getAuctionIndexsByPage(pageSize.value, pageCount.value, daoId.value, aucStatus, onlyOwner);

  if(indexs.length < pageSize.value){
    hasMore.value = false;
  }else{
    hasMore.value = true;
  }

  const infoList = new Array();
  for(const i in indexs){
    const res = await greenauction.getAuctionInfoById(indexs[i]);
    const erc721 = new ERC721(res.nftContract);

    res.tokenSymbol = await getTokenCurencyName(res.payContract);
    try{
      res.nftUrl = await erc721.tokenURI(res.nftId);
    }catch(e){
      res.nftUrl = '';
    }
    
    res.nftName = await erc721.name();
    res.nftSymbol = await erc721.symbol();
    res.isOwner = res.nftOwner.toLowerCase() === connectState.userAddr.value.toLowerCase();

    //if dao not exists, skip
    try{
      const daoInfo = await greendao.getDaoInfoById(res.daoId);
      res.daoName = daoInfo.daoName;
      res.daoAvatar = daoInfo.daoAvatar;
      res.daoWebsite = daoInfo.daoWebsite;
      res.daoDesc = daoInfo.daoDesc;
      res.daoOwner = daoInfo.daoOwner;
      res.daoPublic = daoInfo.daoPublic;
      res.daoMembers = daoInfo.daoMembers;
    }catch(e){
      continue;
    }

    infoList.push(res);
  }

  greenAuctionList.value = infoList;  
}

//handle page refresh
const handleClick = async () => {
  //wait for the active name change
  await tools.sleep(100);
    
  connectState.activeName.value = activeName.value;
  tools.setUrlParamter('activeName', activeName.value);
  try{
    loadStatus.value = true;
    if (!(await connected())){
      greenAuctionList.value = new Array();
      return;
    }

    if(pageCount.value < 0){
      pageCount.value = 0;
    }

    const onlyOwner = false;

    let aucStatus = 0;
    if(activeName.value === 'upcoming'){
      aucStatus = 0;
    }else if(activeName.value === 'ongoing'){
      aucStatus = 1;
    }else{
      aucStatus = 6;
    }

    await getGreenAuctionCount(aucStatus, onlyOwner);

  }catch(e){
    greenAuctionList.value = new Array();
  }finally{
    loadStatus.value = false;
  }
}

//clean search content and bind search callback function
connectState.search = '';
connectState.searchCallback = handleClick;
//try get activeName from the url paramter
try{
  activeName.value = tools.getUrlParamter('activeName');
  if(activeName.value != 'upcoming' && 
    activeName.value != 'ongoing' &&
    activeName.value != 'finished'){
    activeName.value = 'ongoing';
  }
}catch(e){
  activeName.value = 'ongoing';
}
//update page size
handleClick();

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"background-color":"#ffffff"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: _unref(activeName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : null)),
              class: "file-tabs",
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "Upcoming",
                  name: "upcoming"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Ongoing",
                  name: "ongoing"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Finished",
                  name: "finished"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              style: {"float":"right","margin-right":"50px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => {showAddNewAuctionVisiable.value = true;})
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_drawer, {
              modelValue: showAddNewAuctionVisiable.value,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((showAddNewAuctionVisiable).value = $event)),
              direction: "rtl",
              "destroy-on-close": "",
              onOpened: onAddNewAuctionOpen
            }, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_4, [
                  (auctionId.value > 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                        _createElementVNode("td", _hoisted_6, [
                          _hoisted_7,
                          _createVNode(_component_el_popover, {
                            placement: "top-start",
                            title: "Auction Id",
                            width: 200,
                            trigger: "hover",
                            content: "The id of the green auction."
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_QuestionFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createVNode(_component_el_input, {
                            modelValue: auctionId.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((auctionId).value = $event)),
                            disabled: ""
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_el_icon, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (onClickToCopy(auctionId.value)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Id",
                        width: 200,
                        trigger: "hover",
                        content: "The dao id of the green dao. The auction must be published through the dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_el_input, {
                        modelValue: daoId.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((daoId).value = $event)),
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (updateDaoName(daoId.value))),
                        disabled: auctionId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (onClickToCopy(daoId.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Name",
                        width: 200,
                        trigger: "hover",
                        content: "The name of the green dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(_component_el_input, {
                        modelValue: daoName.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((daoName).value = $event)),
                        disabled: ""
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (onClickToCopy(daoName.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction Start Time",
                        width: 200,
                        trigger: "hover",
                        content: "The start time of the green auction."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: auctionStartTime.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((auctionStartTime).value = $event)),
                        style: {"width":"100%"},
                        type: "datetime",
                        placeholder: "Pick a Date",
                        format: timeFormat
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction End Time",
                        width: 200,
                        trigger: "hover",
                        content: "The end time of the green auction."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: auctionEndTime.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((auctionEndTime).value = $event)),
                        style: {"width":"100%"},
                        type: "datetime",
                        placeholder: "Pick a Date",
                        format: timeFormat
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction Start Price",
                        width: 200,
                        trigger: "hover",
                        content: "The start price of the auction."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createVNode(_component_el_input, {
                        modelValue: auctionStartPrice.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((auctionStartPrice).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (onClickToCopy(auctionStartPrice.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction Reverse Price",
                        width: 200,
                        trigger: "hover",
                        content: "The revere price of the auction. The auction will be failed if the last bid price less than the reverse price."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createVNode(_component_el_input, {
                        modelValue: auctionReversePrice.value,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((auctionReversePrice).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (onClickToCopy(auctionReversePrice.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction Delta Price",
                        width: 200,
                        trigger: "hover",
                        content: "For english auction that means the minimum bid increase. For dutch auction that means the price decrease rate per day."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      _createVNode(_component_el_input, {
                        modelValue: auctionDeltaPrice.value,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((auctionDeltaPrice).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (onClickToCopy(auctionDeltaPrice.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction Type",
                        width: 200,
                        trigger: "hover",
                        content: "You can choose English Auction or Dutch Auction."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      _createVNode(_component_el_select, {
                        modelValue: auctionType.value,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((auctionType).value = $event)),
                        style: {"width":"100%","margin-left":"0px"},
                        placeholder: "Select Auction Type",
                        teleported: false,
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            key: "english",
                            label: "English Auction",
                            value: 0
                          }),
                          _createVNode(_component_el_option, {
                            key: "dutch",
                            label: "Dutch Auction",
                            value: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction Nft Id",
                        width: 200,
                        trigger: "hover",
                        content: "The nft id of the auction to sell."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      _createVNode(_component_el_input, {
                        modelValue: auctionNftId.value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((auctionNftId).value = $event)),
                        disabled: auctionId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (onClickToCopy(auctionNftId.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction Nft Contract",
                        width: 200,
                        trigger: "hover",
                        content: "The nft contract of the auction to sell."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_38, [
                      _createVNode(_component_el_input, {
                        modelValue: auctionNftContract.value,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((auctionNftContract).value = $event)),
                        disabled: auctionId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (onClickToCopy(auctionNftContract.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_39, [
                      _hoisted_40,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Auction Payment Token",
                        width: 200,
                        trigger: "hover",
                        content: "The token contract address for the green auction. You can choose the blockchain native token or the erc20 tokens to receive the payment."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_41, [
                      _createVNode(_component_el_input, {
                        modelValue: auctionPayToken.value,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((auctionPayToken).value = $event)),
                        disabled: auctionId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (onClickToCopy(auctionPayToken.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"flex":"auto"},
                  "element-loading-text": "Submitting...",
                  "element-loading-spinner": svg,
                  "element-loading-svg-view-box": "-10, -10, 50, 50",
                  "element-loading-background": "#ffffff"
                }, [
                  _createVNode(_component_el_button, { onClick: cancelAuctionUpdate }, {
                    default: _withCtx(() => [
                      _hoisted_42
                    ]),
                    _: 1
                  }),
                  (auctionNftApproved.value === false)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: approveNftToken
                      }, {
                        default: _withCtx(() => [
                          _hoisted_43
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (auctionNftApproved.value === true)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        onClick: confirmAuctionUpdate
                      }, {
                        default: _withCtx(() => [
                          _hoisted_44
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, loadDrawerStatus.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          style: {"height":"450px","margin-top":"20px"},
          "element-loading-text": "Loading...",
          "element-loading-spinner": svg,
          "element-loading-svg-view-box": "-10, -10, 50, 50",
          "element-loading-background": "#ffffff"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(greenAuctionList.value, (info) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: info.aucId,
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "box-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: 230,
                              title: "Dao Info"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  type: "success",
                                  target: "_blank",
                                  href: info.daoWebsite
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_avatar, {
                                      src: info.daoAvatar,
                                      size: "small"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 2
                                }, 1032, ["href"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h4", null, "Name: " + _toDisplayString(info.daoName), 1),
                                _createElementVNode("h4", null, [
                                  _hoisted_46,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(greendao).getAddress(),info.daoId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.daoId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, [
                                  _hoisted_47,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: addressExplorerUrl(info.daoOwner)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.daoOwner), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, "Members: " + _toDisplayString(info.daoMembers), 1),
                                _createElementVNode("h4", null, "Public: " + _toDisplayString(info.daoPublic), 1),
                                _createElementVNode("h4", null, "Description: " + _toDisplayString(info.daoDesc), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: 230,
                              title: "Auction Info"
                            }, {
                              reference: _withCtx(() => [
                                _createElementVNode("span", null, [
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(info.nftContract,info.nftId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.nftSymbol + ' : ' + info.nftId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h4", null, [
                                  _hoisted_48,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(greenauction).getAddress(),info.aucId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.aucId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, "Auction Type: " + _toDisplayString(info.acuType === 0 ? 'English Auction' : 'Dutch Auction'), 1),
                                _createElementVNode("h4", null, "Nft Name: " + _toDisplayString(info.nftName), 1),
                                _createElementVNode("h4", null, "Nft Symbol: " + _toDisplayString(info.nftSymbol), 1),
                                _createElementVNode("h4", null, [
                                  _hoisted_49,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(info.nftContract,info.nftId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.nftId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _hoisted_50,
                                _createVNode(_component_el_link, {
                                  type: "success",
                                  target: "_blank",
                                  href: addressExplorerUrl(info.nftOwner)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info.nftOwner), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["href"]),
                                _hoisted_51,
                                _createVNode(_component_el_link, {
                                  type: "success",
                                  target: "_blank",
                                  href: addressExplorerUrl(info.bidAddress)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info.nftOwner), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["href"]),
                                (info.aucStatus <= 1)
                                  ? (_openBlock(), _createElementBlock("h4", _hoisted_52, "Start Price: " + _toDisplayString(info.startPrice + ' ' + info.tokenSymbol), 1))
                                  : _createCommentVNode("", true),
                                (info.aucStatus >= 2)
                                  ? (_openBlock(), _createElementBlock("h4", _hoisted_53, "Reverse Price: " + _toDisplayString(info.reversePrice + ' ' + info.tokenSymbol), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("h4", null, "Bid Price: " + _toDisplayString(info.bidPrice + ' ' + info.tokenSymbol), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("span", null, [
                              (info.isOwner === true && info.aucStatus <= 1)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "danger",
                                    style: {"float":"right"},
                                    size: "small",
                                    onClick: ($event: any) => (onCancelGreenAuction(info.aucId))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createElementVNode("iframe", {
                                frameborder: "0",
                                sandbox: "allow-scripts allow-same-origin allow-popups",
                                src: info.nftUrl,
                                style: {"width":"250px","height":"200px"}
                              }, null, 8, _hoisted_54)
                            ]),
                            _: 2
                          }, 1024),
                          (info.aucStatus === 0)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                style: {"float":"right"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, "Starttime: " + _toDisplayString((new Date(info.startTime*1000)).toLocaleString()), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (info.aucStatus === 1)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 1,
                                style: {"float":"right"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, "Endtime: " + _toDisplayString((new Date(info.endTime*1000)).toLocaleString()), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (info.aucStatus === 2)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 2,
                                style: {"float":"right"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_55
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (info.aucStatus === 3)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 3,
                                style: {"float":"right"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_56
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (info.aucStatus === 4)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 4,
                                style: {"float":"right"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_57
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (info.aucStatus === 5)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 5,
                                style: {"float":"right"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_58
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_row, { style: {"float":"right"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_link, {
                                type: "success",
                                style: {"float":"right"},
                                href: "javascript:void(0);"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Current Price: " + _toDisplayString(getCurrentPrice(info).toPrecision(4) + ' ' + info.tokenSymbol), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (info.aucStatus === 0 || info.aucStatus === 1)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    type: "primary",
                                    style: {"float":"right"},
                                    onClick: ($event: any) => (onBidAuction(info))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_59
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (info.aucStatus === 2 || info.aucStatus === 3)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 1,
                                    type: "primary",
                                    style: {"float":"right"},
                                    onClick: ($event: any) => (onClaimAuction(info.aucId))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_60
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, loadStatus.value]
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandlePrev
              }, {
                default: _withCtx(() => [
                  _hoisted_61
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandleNext,
                disabled: !hasMore.value
              }, {
                default: _withCtx(() => [
                  _hoisted_62
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})